export default __webpack_public_path__ + "static/07-73991872e8f145d83d3ad73cbcef208f.jpg";